import React from "react";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import { FieldGroup } from "../index.jsx";
import RCPhoneCountrySelect from "./RCPhoneCountrySelect.jsx";
import { noAutofillProps } from "../../core/noAutofill";

const CustomPhoneInput = ({ field, form, ...props }) => {
  const verification = props.showVerification;
  const phoneInputProps = {
    ...field,
    defaultCountry: props.defaultCountry,
    internationalIcon: () => (
      <img src="/assets/icons/globe.svg" width="16" height="16" alt="" />
    ),
    onChange: (phoneNumber) => form.setFieldValue(field.name, phoneNumber),
    placeholder: props.placeholder,
    disabled: props.disabled,
    // Browser autofill OFF by default on every phone field in the app.
    //
    // Staff type hundreds of DIFFERENT clients' numbers into this origin, and
    // the browser keeps all of them — so it then offers a stranger's number
    // both in the CRM and on the OTP sign-in page. Nothing leaks from the API;
    // the browser saved those values locally. But a suggestion list of other
    // clients' phone numbers is other people's personal data on screen, and one
    // mis-click files it against the wrong person.
    //
    // `off` is not enough on its own — Chrome overrides it for `tel` fields —
    // so this is an unrecognised token. See core/noAutofill.js.
    ...noAutofillProps(field?.name || "phone"),
  };

  // Labelling/validation props are opt-in pass-through: only the ones the call
  // site actually supplied reach the input, so no existing phone field gains an
  // attribute it never asked for. `id` is what lets a <label htmlFor> outside
  // this component resolve to the real input.
  for (const key of ["id", "aria-label", "aria-describedby", "aria-invalid", "required"]) {
    if (props[key] !== undefined) {
      phoneInputProps[key] = props[key];
    }
  }

  if (props.rcCountrySelect) {
    phoneInputProps.countrySelectComponent = RCPhoneCountrySelect;
  }

  const handleChangeNumberClick = (e) => {
    e.preventDefault();
    props.onVerificationCancelled();
  };

  return (
    <div className="w-100">
      {/* <div
                className={`col-xxl-${verification ? '6' : '12'}`}
            > */}
      <PhoneInput
        {...phoneInputProps}
      />
      {/* </div> */}

      {verification && (
        <div className="col-xxl-6" style={{ paddingLeft: "16px" }}>
          <div className="phone-verification">
            <div className="row">
              <div className="col-8">
                <p className="mt-3 mt-xxl-0">
                  Enter the verification code received via SMS:
                  <br />
                  <a href="#" onClick={handleChangeNumberClick}>
                    change number
                  </a>
                </p>
              </div>

              <div className="col-4">
                <FieldGroup
                  placeholder=""
                  type="number"
                  name="phone_code"
                  className="mt-3 mt-xxl-0"
                  maxLength={8}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomPhoneInput;
